import { RippleLoading } from '@/reports/shared/RippleLoading/RippleLoading';
import { Button, Stack } from '@/theme/components';
import { Icons, Text, styled, Modal } from '@/theme/index';
import { HorizontalLine } from '../../components';

const StatusModalContainer = styled(Modal)(({ theme }) => ({
  overflowX: 'hidden',
  '.MuiDialogTitle-root': {
    display: 'flex',
    padding: `0 ${theme.spacing(3)}`,
    margin: `${theme.spacing(2.5)} 0 0 0`,
  },
  '.status-modal': {
    overflowX: 'hidden',
    maxWidth: 'none',
  },
  '.MuiDialogContent-root': {
    width: 'auto',
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      width: '585px',
    },
  },
}));

interface StatusModalProps {
  open: boolean;
  onClose: () => void;
  openEditModal: () => void;
  propertyAddress: string;
  requestStatus?: string;
}

export const StatusModal = ({
  open,
  onClose,
  openEditModal,
  propertyAddress,
  requestStatus,
}: StatusModalProps) => {
  const closeAndRefresh = () => {
    onClose();
    window.location.reload();
  };
  if (requestStatus === 'success') {
    return (
      <StatusModalContainer
        open={open}
        onClose={closeAndRefresh}
        classes={{ paper: 'status-modal' }}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
          }}
        >
          <Text variant="h2" mb={0}>
            Confirm Changes
          </Text>
          <Icons.Close
            onClick={onClose}
            sx={{
              cursor: 'pointer',
            }}
          />
        </Stack>
        <HorizontalLine />
        <Stack
          sx={{
            flexDirection: 'row',
          }}
        >
          <Icons.CheckCircle
            sx={{
              color: (theme) => theme.palette.success.main,
              fontSize: '35px',
            }}
          />
          <Stack paddingLeft={(theme) => theme.spacing(2.5)}>
            <Text>
              You have successfully edited the home facts for{' '}
              {propertyAddress || 'your property'}.
            </Text>
            <br />
            <Text>
              Your changes will now be visible on your property dashboard and
              property report.
            </Text>
          </Stack>
        </Stack>
        <HorizontalLine />
        <Stack width="100%" alignItems="flex-end">
          <Button variant="contained" color="success" onClick={closeAndRefresh}>
            Close Window
          </Button>
        </Stack>
      </StatusModalContainer>
    );
  }
  if (requestStatus === 'error') {
    return (
      <StatusModalContainer
        open={open}
        onClose={onClose}
        classes={{ paper: 'status-modal' }}
      >
        <Stack
          sx={{
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'space-between',
          }}
        >
          <Stack sx={{ flexDirection: 'row', alignItems: 'flex-end' }}>
            <Icons.WarningOutlined color="error" />
            <Text
              variant="h3"
              sx={{
                marginBottom: '0',
                marginLeft: (theme) => theme.spacing(1),
              }}
            >
              Error
            </Text>
          </Stack>
          <Icons.Close
            onClick={onClose}
            sx={{
              cursor: 'pointer',
            }}
          />
        </Stack>
        <HorizontalLine />
        <Stack>
          <Text variant="h3" color={(theme) => theme.palette.error.main}>
            Changes Not Saved
          </Text>
          <Text>
            We're experiencing issues at the moment, please try again later.
          </Text>
          <br />
          <Text>We apologize for any inconvenience. </Text>
        </Stack>
        <HorizontalLine />
        <Stack width="100%" alignItems="flex-end">
          <Button variant="contained" color="success" onClick={openEditModal}>
            Go back
          </Button>
        </Stack>
      </StatusModalContainer>
    );
  }
  return (
    <StatusModalContainer
      open={open}
      onClose={onClose}
      sx={{ padding: 0 }}
      classes={{ paper: 'status-modal' }}
    >
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
        }}
      >
        <Text variant="h2" mb={0}>
          Confirming Changes
        </Text>
      </Stack>
      <HorizontalLine />
      <RippleLoading sx={{ height: '400px' }} />
    </StatusModalContainer>
  );
};
